import { z } from 'zod';
import { isMongoId } from '../../helpers';
import { ddMMyyyy } from '../../helpers/date-format';

export const ListShareSplitsInput = z.object({
  companyId: z.string().refine(isMongoId(), {
    message: 'Invalid company ID',
  }),
});

export const CreateShareSplitInput = z.object({
  companyId: z.string().refine(isMongoId(), {
    message: 'Invalid company ID',
  }),
  date: z.string().regex(ddMMyyyy, 'Date must be in DD/MM/YYYY format'),
  shareSplitFactor: z.number().positive('Share split factor must be positive'),
  sharePricePreSplit: z.number(),
  sharePricePostSplit: z.number(),
});

export const DeleteShareSplitInput = z.object({
  shareSplitId: z.string().refine(isMongoId(), {
    message: 'Invalid share split ID',
  }),
});

export type ListShareSplitsInputType = z.infer<typeof ListShareSplitsInput>;
export type CreateShareSplitInputType = z.infer<typeof CreateShareSplitInput>;
export type DeleteShareSplitInputType = z.infer<typeof DeleteShareSplitInput>;
